<template>
  <!-- width and height are optional -->
  <div class="absolute -bottom-32 -left-36">
    <lottie
      :width="300"
      :height="400"
      :options="lottieOptions"
      v-on:animCreated="handleAnimation"
    />
  </div>
</template>

<script>
import lottie from 'vue-lottie/src/lottie.vue';
import * as thumbsUpAnimation from '@/assets/lottie/thumbs-up.json';
import * as laughAnimation from '@/assets/lottie/laugh.json';
import * as sadAnimation from '@/assets/lottie/sad.json';
import * as applausAnimation from '@/assets/lottie/applause.json';
import * as rocketAnimation from '@/assets/lottie/rocket.json';
import * as heartAnimation from '@/assets/lottie/heart.json';

export default {
  components: {
    lottie,
  },

  props: {
    reactionName: {
      type: String,
      required: true,
      default: 'applaus',
    },
  },
  data() {
    return {
      anim: null, // for saving the reference to the animation
    };
  },
  computed: {
    lottieOptions() {
      let animationData = null;

      switch (this.reactionName) {
        case 'thumbs-up': {
          animationData = thumbsUpAnimation;
          break;
        }
        case 'funny': {
          animationData = laughAnimation;
          break;
        }
        case 'sad': {
          animationData = sadAnimation;
          break;
        }
        case 'claps': {
          animationData = applausAnimation;
          break;
        }
        case 'rocket': {
          animationData = rocketAnimation;
          break;
        }
        case 'love': {
          animationData = heartAnimation;
          break;
        }

        default: {
          animationData = rocketAnimation;
          break;
        }
      }

      return {
        animationData: animationData.default,
        loop: true,
        renderer: 'svg',
        autoplay: true,
      };
    },
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
  },
};
</script>
